module.exports = __webpack_public_path__ + "static/img/cont34 (9).2b75404.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont34 (9).jpg
// module id = 9dyw
// module chunks = 0